import {ChangeDetectionStrategy, Component, OnDestroy, OnInit,} from '@angular/core';
import {TranslationService} from './modules/i18n/translation.service';
// language list
import {locale as enLang} from './modules/i18n/vocabs/en';
import {locale as frLang} from './modules/i18n/vocabs/fr';
import {SplashScreenService} from './_metronic/partials/layout/splash-screen/splash-screen.service';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {TableExtendedService} from './_metronic/shared/crud-table';
import {UtilityFunc} from './shared/base/utils';
import {Constants} from './shared/base/constants';
import {AppSetting} from './shared/base/app.setting';
import {ThemeService} from './shared/services/theme.service';


import { filter } from 'rxjs/operators';
declare const gtag: Function;

declare var window: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  constructor(
    private translationService: TranslationService,
    private splashScreenService: SplashScreenService,
    private router: Router,
    private tableService: TableExtendedService,
    private themeService: ThemeService
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      frLang
    );
      UtilityFunc.setLocalStorage(Constants.LOCAL_STORAGE_DATABASE,AppSetting.db.isDbEnabled)
  }

  ngOnInit() {

    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // clear filtration paginations and others
        this.tableService.setDefaults();
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);

      this.router.events.pipe(
          filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
          /** START : Code to Track Page View  */
          gtag('event', 'page_view', {
              page_path: event.urlAfterRedirects
          })
          /** END */
      })


    // window.Intercom("boot", {
    //   // api_base: "https://api-iam.intercom.io",
    //   app_id: "k8v10ykx"
    // });
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
